import { ActivityInformationTravellerModel } from '../../../../features/activities/informationDisplays/api/useActivityInformationTravellersQuery.ts';
import { useMemo } from 'react';
import { ContactInfoBar } from '../../../../components/ContactInfoBar/ContactInfoBar.tsx';
import { EmailAddressType } from '../../../../enums/crm/EmailAddressType.ts';

type Props = {
  contact: ActivityInformationTravellerModel;
};
/**
 * ActivityInformationTravellerContactInfoBar component transforms a traveler’s contact fields into
 * a unified contact toolbar using the ContactInfoBar component.
 *
 * Responsibilities:
 * - Uses the EmailAddresses list from the traveler model, filtering for Primary, Business, and Personal addresses.
 * - Filters out any empty or undefined email entries.
 * - Passes the filtered emails, fax numbers (none), and existing phone numbers to ContactInfoBar.
 *
 * @component
 * @param {{
 *   contact: ActivityInformationTravellerModel; // Traveler model containing EmailAddresses and PhoneNumbers
 * }} props
 * @returns {JSX.Element} A ContactInfoBar populated with the traveler’s emails and phone numbers, or null if no data.
 */
export const ActivityInformationTravellerContactInfoBar = (props: Props) => {
  const filteredEmails = useMemo(() => {
    return (
      props.contact.EmailAddresses?.filter(
        (email) =>
          email.Address &&
          (email.Type === EmailAddressType.Primary ||
            email.Type === EmailAddressType.Business ||
            email.Type === EmailAddressType.Personal)
      ) || []
    );
  }, [props.contact.EmailAddresses]);

  return <ContactInfoBar emails={filteredEmails} faxNumbers={[]} phoneNumbers={props.contact.PhoneNumbers} />;
};
